// extracted by mini-css-extract-plugin
export var active = "_a3-d";
export var blink = "_a3-e";
export var container = "_a3-5";
export var controls = "_a3-0";
export var controlsRight = "_a3-1";
export var fakeCursor = "_a3-c";
export var hidden = "_a3-b";
export var quillContainerSmall = "_a3-7";
export var quillEditor = "_a3-6";
export var quillEditorSmall = "_a3-8";
export var quillFormatButtons = "_a3-a";
export var quillToolbar = "_a3-9";
export var removePadding = "_a3-2";
export var state = "_a3-3";
export var stateTitle = "_a3-4";